import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { SUBMIT_LOYALTY_POINTS_BURN_CALCULATION } from 'actions/apiActionConstants'
import requestLoyaltyPointsBurnCalculation from 'api/loyalty/requestLoyaltyPointsBurnCalculation'
import getLoyaltyPointBurnCalculationKey from 'checkout/lib/utils/loyalty/getLoyaltyPointBurnCalculationKey'

/**
 * Checkout-specific burn calculation using the singular /calculate-burn endpoint.
 * For search/offer page batch burn, use submitLoyaltyPointsBurnCalculationRequest instead.
 */
function submitLoyaltyPointsBurnCalculationRequests(
  calculationRequests: Array<App.Checkout.LoyaltyPointBurnCalculationRequest>,
): AppAction {
  return (dispatch, getState) => {
    if (!calculationRequests.length) return

    const state = getState()

    const pointsBurnCalculationKey = getLoyaltyPointBurnCalculationKey(calculationRequests)
    const existingCalculation = state.loyalty.pointsBurnCalculations[pointsBurnCalculationKey]

    if (
      existingCalculation?.data ||
      existingCalculation?.fetching ||
      existingCalculation?.error
    ) return

    const customerId = state.auth.account.memberId

    dispatch({
      type: API_CALL,
      api: SUBMIT_LOYALTY_POINTS_BURN_CALCULATION,
      pointsBurnCalculationKey,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
      request: () => requestLoyaltyPointsBurnCalculation(
        calculationRequests,
        {
          customerId: customerId!,
        },
      ),
    })
  }
}

export default submitLoyaltyPointsBurnCalculationRequests
